import React, { useCallback } from 'react';
import { format } from 'date-fns';
import type { ChecklistTemplate } from 'contracts/ChecklistTemplate';
import * as S from './styles';

interface Props {
  templates: ChecklistTemplate[];
  onDelete: (template: ChecklistTemplate) => void;
  deletingId?: number | null;
}

interface ItemProps {
  template: ChecklistTemplate;
  onDelete: (template: ChecklistTemplate) => void;
  deletingId?: number | null;
}

export const TemplatesList: React.FC<Props> = ({
  templates,
  onDelete,
  deletingId,
}) => {
  const Item = useCallback(
    ({ template, onDelete, deletingId }: ItemProps): JSX.Element => {
      const { id, name, slug, google_id, created_at } = template;
      const isDeleting = deletingId === id;

      return (
        <S.ListItem>
          <S.Column>{id}</S.Column>
          <S.Column title={name}>{name}</S.Column>
          <S.Column title={slug || '-'}>{slug || '-'}</S.Column>
          <S.Column title={google_id}>{google_id}</S.Column>
          <S.Column>
            {created_at
              ? format(new Date(created_at), 'dd/MM/yyyy HH:mm')
              : '-'}
          </S.Column>
          <S.ActionsColumn>
            <S.LinkActionButton
              to={`/configuracoes/checklist/modelos/${id}/editar`}
            >
              <S.EditIcon />
            </S.LinkActionButton>
            <S.ActionButton
              mood="void"
              title="Excluir checklist"
              disabled={isDeleting}
              onClick={() => onDelete(template)}
            >
              <S.TrashIcon />
            </S.ActionButton>
          </S.ActionsColumn>
        </S.ListItem>
      );
    },
    []
  );

  if (!templates.length) {
    return <S.EmptyState>Nenhum modelo de checklist cadastrado.</S.EmptyState>;
  }

  return (
    <S.List>
      <S.ListHeader>
        <S.Column>ID</S.Column>
        <S.Column>NOME</S.Column>
        <S.Column>SLUG</S.Column>
        <S.Column>GOOGLE FORM ID</S.Column>
        <S.Column>CRIADO EM</S.Column>
        <div />
      </S.ListHeader>
      {templates.map((template) => (
        <Item
          key={template.id}
          template={template}
          onDelete={onDelete}
          deletingId={deletingId}
        />
      ))}
    </S.List>
  );
};
